import { retrieveFirmLawWorksCharges } from "@/lib/data/requests/firm/lawworks-charges";
import { queryKeys } from "@/lib/data/static/query-keys";

export const retrieveFirmLawWorksChargesQueryOptions = (
  data: Parameters<typeof retrieveFirmLawWorksCharges>[0] = {},
) => ({
  queryKey: [
    queryKeys.firmLawWorksCharges,
    data.startDate,
    data.endDate,
    data.pageNumber ?? 1,
    data.pageSize ?? 25,
  ],
  queryFn: () => retrieveFirmLawWorksCharges(data),
});
